export enum ReminderInterval {
  Never = 'Never',
  Daily = 'Daily',
  TwiceAWeek = 'TwiceAWeek',
  Weekly = 'Weekly',
  ADayBeforeExpiration = 'ADayBeforeExpiration',
}
